import { createTheme } from "@mui/material/styles";

export default createTheme({
  palette: {
    primary: {
      main: "#FF6B35", // Vibrant orange - energetic fitness color
      light: "#FF8A5B",
      dark: "#E55A2B",
    },
    secondary: {
      main: "#2D3142", // Dark navy/charcoal
      light: "#4F5D75",
      dark: "#1A1D2E",
    },
    info: {
      main: "#4ECDC4", // Teal accent
      light: "#6FE4DA",
      dark: "#3BA89E",
    },
    success: {
      main: "#4CAF50",
    },
    warning: {
      main: "#FFA726",
    },
    error: {
      main: "#EF5350",
    },
    dark: {
      main: "#2D3142",
    },
    text: {
      primary: "#2D3142",
      secondary: "#6B7280",
    },
    background: {
      default: "#FFFFFF",
      paper: "#F9FAFB",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 16,
    h1: {
      fontSize: "3rem",
      fontWeight: 700,
      lineHeight: 1.25,
    },
    h2: {
      fontSize: "2.25rem",
      fontWeight: 700,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: "1.875rem",
      fontWeight: 700,
      lineHeight: 1.375,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 600,
      lineHeight: 1.375,
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 600,
      lineHeight: 1.375,
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 600,
      lineHeight: 1.625,
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.625,
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.6,
    },
    size: {
      xxs: "0.625rem",
      xs: "0.75rem",
      sm: "0.875rem",
      md: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "1.875rem",
      "4xl": "2.25rem",
      "5xl": "3rem",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1400,
    },
  },
  shadows: [
    "none",
    "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
    "0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1), 0 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.06)",
    "0 0.3125rem 0.625rem 0 rgba(0, 0, 0, 0.12)",
    "0 0.5rem 1.25rem 0 rgba(0, 0, 0, 0.14)",
    "0 0.5rem 1.5rem 0 rgba(0, 0, 0, 0.16)",
    "0 0.75rem 1.5rem 0 rgba(0, 0, 0, 0.12)",
    "0 0.9375rem 1.875rem 0 rgba(0, 0, 0, 0.12)",
    "0 1rem 2rem 0 rgba(0, 0, 0, 0.14)",
    "0 1.25rem 2.5rem 0 rgba(0, 0, 0, 0.16)",
    "0 1.5rem 3rem 0 rgba(0, 0, 0, 0.16)",
    "0 1.75rem 3.5rem 0 rgba(0, 0, 0, 0.16)",
    "0 2rem 4rem 0 rgba(0, 0, 0, 0.16)",
    "0 2.25rem 4.5rem 0 rgba(0, 0, 0, 0.16)",
    "0 2.5rem 5rem 0 rgba(0, 0, 0, 0.16)",
    "0 2.75rem 5.5rem 0 rgba(0, 0, 0, 0.16)",
    "0 3rem 6rem 0 rgba(0, 0, 0, 0.16)",
    "0 3.25rem 6.5rem 0 rgba(0, 0, 0, 0.18)",
    "0 3.5rem 7rem 0 rgba(0, 0, 0, 0.18)",
    "0 3.75rem 7.5rem 0 rgba(0, 0, 0, 0.18)",
    "0 4rem 8rem 0 rgba(0, 0, 0, 0.18)",
    "0 4.25rem 8.5rem 0 rgba(0, 0, 0, 0.2)",
    "0 4.5rem 9rem 0 rgba(0, 0, 0, 0.2)",
    "0 4.75rem 9.5rem 0 rgba(0, 0, 0, 0.2)",
    "0 5rem 10rem 0 rgba(0, 0, 0, 0.2)",
  ],
});

